import _ from 'lodash';

// service
import UserService from '@/services/UserService';

// BaseModel
import BaseModel from '@/models/BaseModel';
import ImageModel from '@/models/ImageModel';

class UserModel extends BaseModel {
  // eslint-disable-next-line
  get defaults() {
    const baseDefaults = super.defaults;
    const defaults = {
      id: null,
      description: null,
      email: null,
      firstname: null,
      image_id: null,
      lastname: null,
      position: null,
      username: null,
      image: null,
    };

    return _.extend(baseDefaults, defaults);
  }

  constructor(props = {}) {
    super(props);
    if (props.image) {
      this.image = new ImageModel(props.image);
    }
  }

  destroy() {
    if (this.id) {
      UserService.delete(this.id);
    }
  }
}

export default UserModel;
